import React from 'react';
import styles from './Container.module.css';

const Container = ({children, className = '', as: Tag = 'div'}) => (
    <Tag className={`${styles.container} ${className}`.trim()}>
        {children}
    </Tag>
);

export default Container;
